;globalThis["_sentryRouteManifest"] = "{\"isrRoutes\":[],\"dynamicRoutes\":[],\"staticRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.1.6";import * as Sentry from '@sentry/nextjs';

Sentry.init({
	dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
	environment: process.env.NEXT_PUBLIC_ENV,
	tracesSampleRate: 0.25,
	enabled: process.env.NEXT_PUBLIC_ENV !== 'development',
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
